var map = {
	"./affection-baby-baby-girl-beautiful-377058.jpg": 35,
	"./beautiful-&-simple.jpg": 36,
	"./cestovat-chladny-dno-jednoduchost-2868847.jpg": 37,
	"./fitness-blog-post.jpg": 38,
	"./giphy.gif": 12,
	"./memories-from.jpg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;